import React from "react";
import Card from "../../components/Card/Card";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const AuthDetailsPage = () => {
  const location = useLocation();
  const userDetails = location.state;

  return (
    <div className="bx--row">
      <div className="bx--col-sm-12 bx--col-lg-8">
        <Card title="Detalhes da conta">
          <p>A sua conta foi recuperada com sucesso.</p>
          <p>Memorize estes dados para aceder à plataforma</p>
          <p className="mt-1">
            <strong>Número de Telefone:</strong> {userDetails?.username}
          </p>
          <p>
            <strong>Senha:</strong> {userDetails?.password}
          </p>
          <p style={{ color: "#000" }} className="mt-1">
            <Link to={"../"}>Clique aqui para aceder a plataforma</Link>
          </p>
        </Card>
      </div>
    </div>
  );
};

export default AuthDetailsPage;
